const ADULT = 'ADT';
const CHILD = 'CNN';
const INFANT = 'INF';
export default {
  ADULT,
  CHILD,
  INFANT
};
//# sourceMappingURL=ageTypes.js.map